export default __webpack_public_path__ + "static/media/astro-scene_5.064a2b7e.jpeg";